// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-view {
    padding: 20px 0;
    text-align: center;
}
.user-view .profile-image {
    display: block;
    margin: 10px auto;
    max-width: 200px;
    height: 200px;
}
.user-view .details {
    min-height: 150px;
    font-size: 16px;
    max-width: 400px;
    margin: 0 auto;
}
.user-view .details .bio {
    font-size: 14px;
}
.user-view .details div {
    padding: 12px;
}
.user-view .name {
    font-size: 2em;
}
.user-view .details svg {
    width: 20px;
    margin-right: 5px;
    margin-bottom: -5px;
    color: var(--icon-color); 
}
`, "",{"version":3,"sources":["webpack://./client/components/users/UserView.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,aAAa;AACjB;AACA;IACI,iBAAiB;IACjB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;AACA;IACI,eAAe;AACnB;AACA;IACI,aAAa;AACjB;AACA;IACI,cAAc;AAClB;AACA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,wBAAwB;AAC5B","sourcesContent":[".user-view {\n    padding: 20px 0;\n    text-align: center;\n}\n.user-view .profile-image {\n    display: block;\n    margin: 10px auto;\n    max-width: 200px;\n    height: 200px;\n}\n.user-view .details {\n    min-height: 150px;\n    font-size: 16px;\n    max-width: 400px;\n    margin: 0 auto;\n}\n.user-view .details .bio {\n    font-size: 14px;\n}\n.user-view .details div {\n    padding: 12px;\n}\n.user-view .name {\n    font-size: 2em;\n}\n.user-view .details svg {\n    width: 20px;\n    margin-right: 5px;\n    margin-bottom: -5px;\n    color: var(--icon-color); \n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
